import { geoViewColors } from '@/ui/style/default';
import type { IGeoViewColors } from '@/ui/style/types';

/** Geo.ca theme color palette, extends the default GeoView colors */
export const geoCaThemeColors: IGeoViewColors = {
  ...geoViewColors,
};
